import React, { useState } from "react";
import CustomButton from "../../Components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { showToast } from "../../utils/helpers";
import { Button } from "react-bootstrap";

interface SubAvailabilityFormType {
  isLoading: boolean;
  addItemToDay: Function;
}

const SubAvailabilityForm: React.FC<SubAvailabilityFormType> = ({
  isLoading,
  addItemToDay,
}) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const validate = () => {
    if (startTime === "") {
      showToast("error", "Please enter start time");
    } else if (endTime === "") {
      showToast("error", "Please enter end time");
    } else if (startTime == endTime) {
      showToast("error", "End time must not be the same as start time.");
    } else if (startTime > endTime) {
      showToast("error", "End time should be greater then start time");
    } else {
      setStartTime("");
      setEndTime("");

      addItemToDay(startTime, endTime);
    }
  };

  return (
    <div className="schedule-form mt-0" style={{ marginRight: 10 }}>
      <div className="form-group">
        <input
          type="time"
          name="startTime"
          className="form-control"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
        />
      </div>
      <span>to</span>
      <div className="form-group">
        <input
          type="time"
          name="endTime"
          className="form-control"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
        />
      </div>

      <Button onClick={() => validate()}>
        {isLoading && <FontAwesomeIcon icon={faSpinner} size="xs" spin />}

        {!isLoading && <FontAwesomeIcon icon={faPlus} />}
      </Button>
    </div>
  );
};

export default SubAvailabilityForm;
